import { render, staticRenderFns } from "./hi-button.vue?vue&type=template&id=282926a3"
import script from "./hi-button.vue?vue&type=script&lang=ts"
export * from "./hi-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports